import React, { useEffect, useState } from 'react'
import "../AdminDashboard.css"
import "./GetMember.css"
import axios from "axios"
import moment from "moment"
import { Card, Badge, Select } from '../../../../ui'
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import BookIcon from '@material-ui/icons/Book';
import HistoryIcon from '@material-ui/icons/History';
import CircularProgress from '@material-ui/core/CircularProgress';

function GetMember() {
    const API_URL = process.env.REACT_APP_API_URL

    const [allMembersOptions, setAllMembersOptions] = useState(null)
    const [memberId, setMemberId] = useState(null)
    const [memberDetails, setMemberDetails] = useState(null)
    const [loading, setLoading] = useState(false)

    //Fetch Members - load on focus
    const loadMembers = async () => {
        if (allMembersOptions && allMembersOptions.length > 0) return; // Already loaded
        try {
            const response = await axios.get(API_URL + "api/users/allmembers")
            if (response.data && response.data.length > 0) {
                setAllMembersOptions(response.data.map((member) => (
                    { value: `${member?._id}`, text: `${member?.userType === "Student" ? `${member?.userFullName}[${member?.admissionId}]` : `${member?.userFullName}[${member?.employeeId}]`}` }
                )))
            }
        }
        catch (err) {
            console.log("Error loading members:", err)
        }
    }

    useEffect(() => {
        const getMemberDetails = async () => {
            if (memberId !== null) {
                setLoading(true)
                try {
                    const response = await axios.get(API_URL + "api/users/getuser/" + memberId)
                    setMemberDetails(response.data)
                }
                catch (err) {
                    console.log("Error in fetching the member details")
                }
                setLoading(false)
            }
        }
        getMemberDetails()
    }, [API_URL, memberId])

    const activeBooks = memberDetails?.activeTransactions?.filter((data) => {
        return data.transactionType === "Issued"
    }) || []

    const reservedBooks = memberDetails?.activeTransactions?.filter((data) => {
        return data.transactionType === "Reserved"
    }) || []

    const calculateFine = (toDate) => {
        const daysOverdue = Math.floor((Date.parse(moment(new Date()).format("MM/DD/YYYY")) - Date.parse(toDate)) / 86400000)
        return daysOverdue <= 0 ? 0 : daysOverdue * 10
    }

    return (
        <div className="getmember-container">
            <h2 className="getmember-title">Get Member Details</h2>

            <Card padding="md" className="getmember-filter-card">
                <Select
                    id="member-select"
                    label="Select Member"
                    placeholder="Select Member"
                    searchable
                    clearable
                    value={memberId}
                    options={allMembersOptions || []}
                    onChange={(e) => setMemberId(e.target.value)}
                    onFocus={loadMembers}
                    onOpen={loadMembers}
                />
            </Card>

            {loading ? (
                <Card padding="lg" className="getmember-loading">
                    <CircularProgress />
                    <p>Loading member details...</p>
                </Card>
            ) : memberDetails && memberId ? (
                <div className="getmember-details">
                    {/* Profile Section */}
                    <Card padding="lg" className="getmember-profile-card">
                        <div className="getmember-profile-header">
                            <div className="getmember-profile-avatar">
                                <AccountCircleIcon style={{ fontSize: 80 }} />
                            </div>
                            <div className="getmember-profile-info">
                                <h3 className="getmember-profile-name">{memberDetails.userFullName}</h3>
                                <Badge variant="primary" className="getmember-profile-badge">
                                    {memberDetails.userType === "Student" ? memberDetails.admissionId : memberDetails.employeeId}
                                </Badge>
                                <p className="getmember-profile-email">{memberDetails.email}</p>
                                <p className="getmember-profile-phone">{memberDetails.mobileNumber}</p>
                            </div>
                        </div>

                        <div className="getmember-profile-details">
                            <div className="getmember-profile-grid">
                                <Card padding="md" className="getmember-info-card">
                                    <span className="getmember-label">Age</span>
                                    <span className="getmember-value">{memberDetails.age || 'N/A'}</span>
                                </Card>
                                <Card padding="md" className="getmember-info-card">
                                    <span className="getmember-label">Gender</span>
                                    <span className="getmember-value">{memberDetails.gender || 'N/A'}</span>
                                </Card>
                                <Card padding="md" className="getmember-info-card">
                                    <span className="getmember-label">Date of Birth</span>
                                    <span className="getmember-value">{memberDetails.dob || 'N/A'}</span>
                                </Card>
                                <Card padding="md" className="getmember-info-card">
                                    <span className="getmember-label">Address</span>
                                    <span className="getmember-value">{memberDetails.address || 'N/A'}</span>
                                </Card>
                            </div>

                            <div className="getmember-profile-stats">
                                <Card padding="lg" className="getmember-stat-card">
                                    <span className="getmember-stat-label">Points</span>
                                    <span className="getmember-stat-value">{memberDetails.points || 0}</span>
                                </Card>
                                <Card padding="lg" className="getmember-stat-card">
                                    <span className="getmember-stat-label">Rank</span>
                                    <span className="getmember-stat-value">{memberDetails.rank || 'N/A'}</span>
                                </Card>
                            </div>
                        </div>
                    </Card>

                    {/* Active Books Section */}
                    <div className="getmember-section">
                        <h3 className="getmember-section-title">Issued Books</h3>
                        {activeBooks.length > 0 ? (
                            <Card padding="md" className="getmember-table-card">
                                <div className="getmember-table-wrapper">
                                    <table className="getmember-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Book Name</th>
                                                <th>From Date</th>
                                                <th>To Date</th>
                                                <th>Fine</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {activeBooks.map((data, index) => {
                                                const fine = calculateFine(data.toDate)
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{data.bookName}</td>
                                                        <td>{data.fromDate}</td>
                                                        <td>{data.toDate}</td>
                                                        <td>
                                                            <Badge variant={fine > 0 ? "danger" : "success"}>
                                                                ₹{fine}
                                                            </Badge>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </Card>
                        ) : (
                            <Card padding="lg" className="getmember-empty-state">
                                <BookIcon style={{ fontSize: 48, marginBottom: 16 }} />
                                <p>No issued books found.</p>
                            </Card>
                        )}
                    </div>

                    {/* Reserved Books Section */}
                    <div className="getmember-section">
                        <h3 className="getmember-section-title">Reserved Books</h3>
                        {reservedBooks.length > 0 ? (
                            <Card padding="md" className="getmember-table-card">
                                <div className="getmember-table-wrapper">
                                    <table className="getmember-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Book Name</th>
                                                <th>From</th>
                                                <th>To</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reservedBooks.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{data.bookName}</td>
                                                    <td>{data.fromDate}</td>
                                                    <td>{data.toDate}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Card>
                        ) : (
                            <Card padding="lg" className="getmember-empty-state">
                                <BookIcon style={{ fontSize: 48, marginBottom: 16 }} />
                                <p>No reserved books found.</p>
                            </Card>
                        )}
                    </div>

                    {/* History Section */}
                    <div className="getmember-section">
                        <h3 className="getmember-section-title">History</h3>
                        {memberDetails.prevTransactions && memberDetails.prevTransactions.length > 0 ? (
                            <Card padding="md" className="getmember-table-card">
                                <div className="getmember-table-wrapper">
                                    <table className="getmember-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Book Name</th>
                                                <th>From</th>
                                                <th>To</th>
                                                <th>Return Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {memberDetails.prevTransactions.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{data.bookName}</td>
                                                    <td>{data.fromDate}</td>
                                                    <td>{data.toDate}</td>
                                                    <td>{data.returnDate}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Card>
                        ) : (
                            <Card padding="lg" className="getmember-empty-state">
                                <HistoryIcon style={{ fontSize: 48, marginBottom: 16 }} />
                                <p>No transaction history found.</p>
                            </Card>
                        )}
                    </div>
                </div>
            ) : (
                <Card padding="lg" className="getmember-empty-state">
                    <AccountCircleIcon style={{ fontSize: 48, marginBottom: 16 }} />
                    <p>Select a member to view their details.</p>
                </Card>
            )}
        </div>
    )
}

export default GetMember
